
import React, { Component } from 'react';
import MainWrapper from '../main-wrapper';
import authentication from '../../services/authentication';
class Login extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
   
    this.state = {
      flag : false
    }
  }

  // Function for login submit //

  loginevent(username,password){
    // console.log("username is :: "+username +"and password "+password);

    this.historyDta={
      calling:this,
      userId:username,
      userPwd:password
    }
    // console.log(this.historyDta);
    authentication(this.historyDta)
    
      }
  
  handleSubmit(e) {
    e.preventDefault();
    this.loginevent(this.input.value,this.pass.value);
 
  }

  /**
   * Callback for Auth Service
   * @param {string} auth_token 
   * @param {boolean} success 
   */
  setAuthToken=(auth_token, success)=>{
    this.setState({
      authToken: auth_token,
      authStatus: success
    });

    const { authStatus } = this.state;
    if(authStatus){
    this.props.history.push({
      pathname:"/EN/orders/all",
      state:{
        authToken:auth_token,
        authStatus: success
       }
     });
    }
  }
  render() {
    document.querySelector('body').style.backgroundColor='#FFB91D';
    const { authStatus } = this.state;
    // console.log(authStatus);
    var errorMsg = '';
    // console.log("authStatus value : "+authStatus);
    if(!authStatus && authStatus!==undefined){
      errorMsg = 'Please Enter Valid Username or Password.';
      alert(errorMsg);
      // console.log(errorMsg);
    }
      return(
    <div className="container-fluid login">
      
    <div className="wrap-login100">
<div className="logo-here">
<img src="/assets/img/parker-logo.png" className="img-fluid" />
</div>


<form className="login100-form " onSubmit={this.handleSubmit}>
<div className="form-title">
<span className="form-logo">
<img src="/assets/img/fast-delivery.png" />
</span>
<span>
Order Status Login
</span>
</div>
<div className="wrap-input100 validate-input" data-validate="Enter username">
  <input className="input100" type="text" name="username" ref={(input) => this.input = input}  placeholder="Username"/>
<span className="symbol-input100">
<span className="fa fa-user"></span>
</span>
</div>
<div className="wrap-input100 validate-input" data-validate="Enter password">
  <input className="input100" type="password" name="pass" ref={(input) => this.pass = input}  placeholder="Password"/>
 <span className="symbol-input100">
<span className="fa fa-lock"></span>
</span>
</div>
<div className="container-login100-form-btn">
  <button className="login100-form-btn">
  Sign-In
  </button>
</div>

</form>

</div>
     
  </div>
      );
  }
}
  
  export default Login;


